import component from './components/reportsubscriptions';

export default {
    component
};